import React from 'react';

import { aiMessages } from '@atlaskit/editor-common/ai-messages';
import type { ExtensionManifest } from '@atlaskit/editor-common/extensions';
import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';

import { AIPanelRenderer } from '../../ai-panel-renderer/AIPanelRenderer';
import type { AIManifest, AIPanelParameters } from '../../types';

const buildSummarisePagePanelManifest = ({
	intl,
	providerFactory,
}: AIManifest): ExtensionManifest<AIPanelParameters> => {
	return {
		title: intl.formatMessage(aiMessages.summarizePageTitle),
		type: 'com.atlassian.ai-blocks',
		key: 'ai-summary-block',
		description: intl.formatMessage(aiMessages.summarisePageDescription),
		icons: {
			// Ignored via go/ees005
			// eslint-disable-next-line require-await
			'48': async () => () => (
				<AtlassianIntelligenceIcon label={intl.formatMessage(aiMessages.summarizePageTitle)} />
			),
		},
		modules: {
			nodes: {
				aiSummaryBodiedExtension: {
					type: 'bodiedExtension',
					// Ignored via go/ees005
					// eslint-disable-next-line require-await
					render:
						async () =>
						({ node }) => {
							return <AIPanelRenderer node={node} providerFactory={providerFactory} />;
						},
				},
			},
		},
	};
};

export default buildSummarisePagePanelManifest;
